// Notice.js

import React, { Component } from 'react';
import { Button, Form } from 'react-bootstrap';
import Config from '../Config';

import ScrollArea from 'react-scrollbar';
import Modal from 'react-awesome-modal';

import { JsonToExcel } from 'react-json-excel';
import axios from 'axios';
import 'semantic-ui-css/semantic.min.css';
import { Icon } from 'semantic-ui-react';

import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import Column from 'react-virtualized/dist/commonjs/Table/Column';
import Table from 'react-virtualized/dist/commonjs/Table';
import SortDirection from 'react-virtualized/dist/commonjs/Table/SortDirection';
import SortIndicator from 'react-virtualized/dist/commonjs/Table/SortIndicator';
import styles from './Table.css';

const className = 'class-name-for-style',
    filename = 'Purchase_Excel-file',
    fields = {
        "ID": "ID",
        "ORDERID": "주문번호",
        "PNUMBER": "상품번호",
        "PNAME": "주문상품명",
        "RECIPIENT": "수령인",
        "AMOUNT": "수량",
        "ORDEREMAIL": "주문자이메일",
        "ORDERNAME": "주문자명",
        "PCODE": "PCODE",
        "ACTIVEDATE": "인증일자", 
    },
    style = {
        padding: "5px",
        background: "#3c8dbc",
        border: "1px #367fa9",
        borderRadius: "3px",
        padding: "6px 12px",
        color: "#ffffff",
        font: "14px",
        height: "37.64px"
    }

export default class PurchaseReg extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sendcount: 0,
            rowlist: [],
            rowCount: 0,
            scrollToIndex: undefined,
            toolbarvisible: false,
            visible: false,
            item: { TITLE: '제목을 입력하세요.', CONTENT: '내용을 입력하세요.', LANGUAGE_CODE: 'ko', COUNTRY_CODE: 'KR' },

        };

        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.fileUpload = this.fileUpload.bind(this);
    }

    handleChange(event) {
        var item = this.state.item;
        item.TITLE = event.target.value;
        this.setState({ item: item });
    }

    handleChangeContent(event) {
        var item = this.state.item;
        item.CONTENT = event.target.value;
        this.setState({ item: item });
    }

    handleChangeLang(event) {
        var item = this.state.item;
        item.LANGUAGE_CODE = event.target.value;
        this.setState({ item: item });
    }

    handleChangeCountry(event) {
        this.setState({ country: event.target.value });
    }

    fetchData(address, params, callback, revalidate = false, cbError) {

        var chcheoption = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (revalidate) {
            // chcheoption['Cache-Control'] = 'must-revalidate';
        }

        fetch(`${Config.Server}/${address}`, {
            // mode: 'no-cors',
            method: 'POST',
            headers: chcheoption,
            body: JSON.stringify(params)
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson);
                if (callback)
                    callback(responseJson.result, responseJson.count);
            })
            .catch((error) => {
                console.error(error);
                cbError(error);
            });
    }

    handleRowClick = (item) => {
        // this.setState({ toolbarvisible: !this.state.toolbarvisible });
        event.preventDefault();
    }

    componentDidMount() {
        this.fetchData('purchaseRegList', {
        }, (result, count) => {
            console.log('count=', count);
            result.forEach(element => {
                console.log('element=', element);
                if(element.ACTIVEDATE == null)
                {                    
                    element.ACTIVEDATE = ''; 
                }
            });
            this.setState({ rowlist: result })
            this.setState({ rowCount: result.length })
        }, true);
    }

    handleClose = () => {
        console.log('handleClose');
        this.setState({ answervisible: false });
    }

    handleScroll(scrollData) {
        console.log(scrollData);
        //this.fetchMoreData();
    }

    _noRowsRenderer() {
        return <div>No rows</div>;
    }

    _onScrollToRowChange(event) {
        const { rowCount } = this.state;
        let scrollToIndex = Math.min(
            rowCount - 1,
            parseInt(event.target.value, 10),
        );

        if (isNaN(scrollToIndex)) {
            scrollToIndex = undefined;
        }

        this.setState({ scrollToIndex });
    }

    _rowClassName({ index }) {
        if (index < 0) {
            return "headerRow";
        } else {
            return index % 2 === 0 ? "evenRow" : "oddRow";
        }
    }

    onChange(e) {
        this.setState({ file: e.target.files[0] });
        this.refs._userfileNames.value = e.target.files[0].name;
    }

    onFormSubmit(e) {
        e.preventDefault() // Stop form submit
        if (this.state.file === null) {
            return;
        }
        this.fileUpload().then((response) => {
            console.log(response.data);

            //alert(response.data);
        })

    }

    fileUpload() {
        const url = `${Config.Server}/file-upload-PurchaseReg`

        //var formData = new FormData(target);

        var formData = new FormData();
        formData.append('csv', this.state.file);
        const config = {
            headers: {
                'content-type': 'multipart/form-data' // multer 사용시 multipart/form-data 형식이어야 한다.
            }
        }
        axios.post(url, formData, config)
            .then((response) => {
                if (response.data.count >= 0) {
                    alert(`${response.data.count}건이 변경되었습니다.`);
                    this.componentDidMount();
                }
                else {
                    alert('형식을 지원하지 않습니다.');
                }
            })
            .catch(function (error) {
                alert(error);
            });
    }



    render() {
        let scrollbarStyles = { borderRadius: 5 };
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="box-header with-border">
                                    <table>
                                        <tr>
                                            <td>
                                                <h3 className="box-title">구매 등록</h3>
                                            </td>
                                            <td width="16"></td>
                                            <td>
                                                {this.state.rowlist.length > 0 ?
                                                    <JsonToExcel
                                                        data={this.state.rowlist}
                                                        className={className}
                                                        filename={filename}
                                                        fields={fields}
                                                        style={style}
                                                    />
                                                    :
                                                    null
                                                }
                                            </td>
                                            <td width="10"></td>
                                            <td>
                                                <Form className="FileUpload" onSubmit={this.onFormSubmit}>
                                                    <div class="ui action input">
                                                        <input placeholder='선택된파일...' type="text" ref="_userfileNames" class="ui" />
                                                        <label for="userfiles" class="ui icon button">
                                                            <Icon name="attach" />
                                                            <input type="file" id="userfiles" accept=".xlsx , .xls , .csv" style={{ display: "none" }} onChange={this.onChange} />
                                                        </label>
                                                        <Button basic ref={(param) => this.uploadButton = param} color="purple" type="submit">구매인증 등록</Button>
                                                    </div>
                                                </Form>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div className="box-body" style={{ margin: 20 }}>
                                    {this.state.toolbarvisible ?
                                        <div className="row">
                                            <Form>
                                                <Button variant="primary">환불</Button>
                                                <Button variant="primary">삭제</Button>
                                            </Form>
                                        </div>
                                        :
                                        null
                                    }
                                    <div className="row">
                                        <AutoSizer disableHeight>
                                            {({ width }) => (
                                                <Table
                                                    ref="Table"
                                                    headerClassName={'headerColumn'}
                                                    onRowClick={this.handleRowClick}
                                                    headerHeight={30}
                                                    height={800}
                                                    noRowsRenderer={this._noRowsRenderer}
                                                    overscanRowCount={10}
                                                    rowClassName={this._rowClassName}
                                                    rowHeight={40}
                                                    rowGetter={({ index }) => this.state.rowlist[index]}
                                                    rowCount={this.state.rowlist.length}
                                                    scrollToIndex={this.state.scrollToIndex}
                                                    width={width}>
                                                    <Column
                                                        width={80}
                                                        disableSort
                                                        label="#"
                                                        dataKey="ID"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={150}
                                                        disableSort
                                                        label="주문번호"
                                                        dataKey="ORDERID"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={80}
                                                        disableSort
                                                        label="상품번호"
                                                        dataKey="PNUMBER"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={200}
                                                        disableSort
                                                        label="주문상품명"
                                                        dataKey="PNAME"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={100}
                                                        disableSort
                                                        label="수령인"
                                                        dataKey="RECIPIENT"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={50}
                                                        disableSort
                                                        label="수량"
                                                        dataKey="AMOUNT"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={100}
                                                        disableSort
                                                        label="이메일"
                                                        dataKey="ORDEREMAIL"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={100}
                                                        disableSort
                                                        label="주문자명"
                                                        dataKey="ORDERNAME"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={50}
                                                        disableSort
                                                        label="PCODE"
                                                        dataKey="PCODE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={50}
                                                        disableSort
                                                        label="인증일자"
                                                        dataKey="ACTIVEDATE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                </Table>
                                            )}
                                        </AutoSizer>
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-6">
                                            <div className="description-block border-right">
                                                {/* <span className="description-percentage text-green"><i className="fa fa-caret-up"></i> 17%</span> */}
                                                {/* <h5 className="description-header">Sending TOTAL: {this.state.sendcount}</h5> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// src/components/PurchaseReg.js